import React, { useEffect, useState } from 'react';

export default function ConsultNoteEditModal({ open, onClose, initialContent = '', title = '상담내역 편집', saving = false, onSave }) {
  const [content, setContent] = useState(String(initialContent || ''));

  useEffect(() => {
    if (open) setContent(String(initialContent || ''));
  }, [open, initialContent]);

  if (!open) return null;

  const handleSave = () => {
    const text = String(content || '').trim();
    if (!text) return;
    if (typeof onSave === 'function') onSave(text);
  };

  return (
    <div className="fixed inset-0 z-[70] flex items-center justify-center">
      <div className="absolute inset-0 bg-black/40" onClick={onClose} />
      <div className="relative bg-white w-full max-w-xl max-h-[90vh] rounded-lg shadow-xl border border-gray-200 overflow-hidden flex flex-col">
        <div className="flex items-center justify-between px-4 py-3 border-b border-gray-200 bg-gray-50">
          <div className="text-sm font-semibold text-gray-900">{title}</div>
          <button onClick={onClose} className="px-2.5 py-1.5 text-xs text-gray-700 hover:bg-gray-100">✕</button>
        </div>
        <div className="p-4 flex-1 overflow-y-auto">
          <label className="block text-xs text-gray-600 mb-1">내용</label>
          <textarea
            rows={10}
            className="w-full border border-gray-300 rounded px-2 py-1.5 text-sm focus:ring-1 focus:ring-blue-500 focus:border-blue-500 resize-y"
            placeholder="상담 내용을 입력하세요."
            value={content}
            onChange={(e)=>setContent(e.target.value)}
          />
          <div className="text-[11px] text-gray-500 mt-1">저장 시 상담내역 목록에 반영됩니다.</div>
        </div>
        <div className="flex items-center justify-end gap-2 px-4 py-3 border-t border-gray-200 bg-white">
          <button onClick={onClose} className="px-3 py-1.5 text-xs rounded border border-gray-300 text-gray-700 hover:bg-gray-100">취소</button>
          <button onClick={handleSave} disabled={saving || !String(content || '').trim()} className="px-3 py-1.5 text-xs rounded bg-blue-600 text-white hover:bg-blue-700 disabled:opacity-50">{saving ? '저장 중...' : '저장'}</button>
        </div>
      </div>
    </div>
  );
}
